import { render, staticRenderFns } from "./aaa.vue?vue&type=template&id=44e2f064&scoped=true&"
import script from "./aaa.vue?vue&type=script&lang=js&"
export * from "./aaa.vue?vue&type=script&lang=js&"
import style0 from "./aaa.vue?vue&type=style&index=0&id=44e2f064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2f064",
  null
  
)

export default component.exports